import { render } from "preact";

import { App } from "./app";
import { About, Methodology, NotFound, knownRoute, staticPage } from "./pages";
import { ProgressPage, isProgressPath } from "./progress";
import "./styles.css";

const root = document.getElementById("app");
if (!root) throw new Error("#app is missing from index.html");

// The static pages are chosen here, before the table app mounts, so they never
// wait on the registry and still render with the API down (REQ-WEB-032,
// REQ-WEB-033). Links to and from them are full page loads; see SiteLinks.
const page = staticPage(location.pathname);
render(
  page === "about" ? <About />
  : page === "methodology" ? <Methodology />
  : isProgressPath(location.pathname) ? <ProgressPage />
  : knownRoute(location.pathname) ? <App />
  : <NotFound />,
  root,
);
